<template>
  <div class="peer-to-wxa">
    <div class="title">微信扫码下单</div>
    <div class="img-box"><img class="wxa-img" :src="codeUrl" v-if="codeUrl"/></div>
  </div>
</template>

<script>
import wxUtils from '../../../../libs/wx-utils';
import User from '../../../../libs/user';
import { env } from '../../../../libs/env';

export default {
  name: 'peer-to-wxa',
  props: {
    visaProductId: {
      type: Number,
      required: true,
      default: 0,
    },
    province_code: {
      type: Number,
    },
  },
  data() {
    return {
      codeUrl: '',
      env,
    };
  },
  watch: {
    visaProductId() {
      this.getWxacode();
    },
  },
  methods: {
    getWxacode() {
      wxUtils.getVisaDetailWxaCode(this.visaProductId, User.peer_account_id, 0, this.province_code)
        .then((base64) => {
          this.codeUrl = base64;
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },
  },
  created() {
    this.getWxacode();
  },
};
</script>

<style lang="less" scoped>
.peer-to-wxa {
  padding-top: 4px;
  width: 106px;
  height: 120px;
  background: #fff;
  display: flex;
  flex-flow: column;
  align-items: center;
  line-height: 1;
  border-radius: 3px;
  border: 2px solid #6FACFF;
  .title {
    font-size: 12px;
    color: #2F333D;
    text-align: center;
  }
  .img-box {
    margin-top: 4px;
    width: 95px;
    height: 95px;
    display: flex;
    justify-content: center;
    align-items: center;
    .wxa-img {
      width: 95px;
      height: 95px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/peer-to-wxa.vue